/* eslint-disable camelcase */
import { withCookiesRestClient } from 'helpers/restclient';

export default class SignUpServices {
	static instance = new SignUpServices();

	_endpoints = {
		signUpPartialData: '/users/new',
		confirmStep: '/users/upsert',
		auctionAccessLookup: '/users/auction_access_lookup',
		auctionAccessCompanyValidation: '/users/auction_access_company_validation',
		salesRepFastPathSignup: '/api/users/registrations/sales_rep_fast_path',
	};

	constructor() {
		this.restClient = withCookiesRestClient;
	}

	confirmStepUpdate = (body) => {
		const endpoint = this._endpoints.confirmStep;
		return this.restClient.post(endpoint, body);
	};

	getSignUpPartialData = (sign_up_token) => {
		const endpoint = this._endpoints.signUpPartialData;
		return sign_up_token ? this.restClient.get(endpoint, { sign_up_token }) : this.restClient.get(endpoint);
	};

	getSignUpPartialDataByEmail = (sign_up_email) => {
		const endpoint = this._endpoints.signUpPartialData;
		return this.restClient.get(endpoint, { sign_up_email });
	};

	lookupAuctionAccess = ({ anonymousId, auctionAccessId, photoIdLastFour }) => {
		const endpoint = this._endpoints.auctionAccessLookup;
		return this.restClient.post(endpoint, {
			auction_access: {
				aa_option_shown: true,
				anonymous_id: anonymousId,
				auction_access_id: auctionAccessId,
				last4_photo_id: photoIdLastFour,
			},
		});
	};

	validateAuctionAccessCompany = ({ companyCandidateId, last4GovernmentId }) => {
		const endpoint = this._endpoints.auctionAccessCompanyValidation;
		return this.restClient.post(endpoint, {
			auction_access: {
				company_candidate_id: companyCandidateId,
				last4_government_id: last4GovernmentId,
			},
		});
	};

	salesRepFastPathSignUp = (signupToken, body = {}) => {
		const token = signupToken?.length > 0 ? signupToken : 'new';
		const endpoint = `${this._endpoints.salesRepFastPathSignup}/${token}`;
		return this.restClient.put(endpoint, body);
	};
}
